
define('template!sdcLoading',[''],function(template){return '<div class="sdc-loading-spinner-wrapper" flex="100" layout layout-align="center center">\r\n\t<div>\r\n\t\t<md-progress-circular md-mode="{{vm.Indeterminate ? \'indeterminate\' : \'determinate\'}}"\r\n\t\t\t\t\t\t\t  ng-value="vm.Progress"\r\n\t\t\t\t\t\t\t  md-diameter="100%"></md-progress-circular>\r\n\t</div>\r\n</div>';});

